import { purifyHTML } from '_lib/purify'
import { getTwEmojiUrl } from '_lib/utils/utils'
import emojiRegex from 'emoji-regex';

const emoji_regex = emojiRegex();

async function processEmoji(el, { text, style, className = '', purify = true }) {
  try {
    // 无表情直接显示
    if (!emoji_regex.test(text)) {
      el.innerHTML = text
      return
    }
    el.innerHTML = renderEmojiHtml(text, style, className, purify)
  } catch (error) {
    el.innerHTML = text
  }
}

function renderEmojiHtml (text, style, className = '', purify = true) {
  // 合并样式
  className = initClassName(className, style)
  const styleString = style ? Object.entries(style).map(([k, v]) => `${k}:${v}`).join(';') : ''

  // 替换表情
  const processed = text.replace(emoji_regex, match => {
    try {
      const url = getTwEmojiUrl(match)
      const styleStr = style ? ` style="${styleString}"` : ''
      return `<img data-emoji="1" src="${url}" alt="${match}" class="${className}"${styleStr} onerror="try{this.outerHTML=this.alt;}catch(e){this.remove();}">`
    } catch (error) {
      return match
    }
  })
  // 更新
  return purify ? purifyHTML(processed, {
    ADD_TAGS: ['img'],
    ADD_ATTR: ['data-emoji', 'src', 'alt', 'class', 'style', 'onerror'],
    ALLOW_DATA_ATTR: true  // 允许所有 data-* 属性
  }) : processed
}

export function getEmojiHtml (text, style, className = '', purify = true) {
  if (!emoji_regex.test(text)) {
    return text
  }
  return renderEmojiHtml(text, style, className, purify)
}

function initClassName(className, style) { 
  className = className || 'w-[16px]'
  if (!style) return className + ' inline-block mt-[-3px]'
  if (!style.display) {
    className += ' inline-block'
  }
  if (!style['margin-top'] && !style.marginTop) {
    className += ' mt-[-3px]'
  }
  return className
}

export const emojiHtmlDirective = {
  async bind(el, binding) {
    await processEmoji(el, binding.value)
  },
  async update(el, binding) {
    await processEmoji(el, binding.value)
  },
  unbind(el) {
    el.innerHTML = ''
  }
}
